import styled from 'styled-components';

export const Container = styled.button`
    position: fixed;
    left: 50%;
    /* 하단 플로팅 선택바(MoveBar)도 가운데 정렬이라 같은 축에 놓인다.
       넓은 화면에서도 비켜갈 수 없으므로 모든 폭에서 선택바 위로 띄운다.
       iOS 홈 인디케이터 영역도 함께 보정. */
    bottom: calc(88px + env(safe-area-inset-bottom, 0px));
    z-index: 1100;

    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    color: #0f172a;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    /* 나타났다 사라질 때 레이아웃에 영향을 주지 않도록 항상 렌더링하고 토글만 한다.
       가운데 정렬용 translateX(-50%)를 슬라이드 transform과 항상 함께 유지해야 한다. */
    opacity: 0;
    pointer-events: none;
    transform: translateX(-50%) translateY(12px);
    transition: opacity .2s ease, transform .2s ease, background .15s;

    &.visible {
        opacity: 1;
        pointer-events: auto;
        transform: translateX(-50%) translateY(0);
    }

    &:hover { background: #f1f5f9; }

    .arrow {
        font-size: 20px;
        font-weight: 800;
        line-height: 1;
    }

    @media all and (min-width: 992px) {
        width: 48px;
        height: 48px;
    }

    @media print {
        display: none;
    }
`;
